"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    d: "m8.334.002-.316.995h2.328l-2.27 5.574 2.474-.012-3.05 4.49.756-3.379H4.73L7.278.002H6.224l-2.88 8.67h3.664l-1.63 7.28 7.066-10.403-2.878.014L11.83.003H8.334Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.434 0 5.116 13.203h5.641L8.421 23.82 18.497 8.741l-4.366.024 3.51-8.759h-5.828l-.351 1.125h4.516l-3.513 8.768 3.92-.02-5.582 8.35 1.354-6.15h-5.49L10.617 0H9.434Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.578 0 6.821 17.604h7.521L11.227 31.76l13.435-20.105-5.82.031L23.52.008h-7.77l-.468 1.5h6.021L16.62 13.199l5.227-.028-7.443 11.135 1.806-8.201H8.89L14.156 0h-1.578Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    d: "m19.126.001-8.772 26.827h11.63L17.35 47.876l19.926-29.818-8.934.049L35.598.002H23.459l-.583 1.874h9.949l-7.26 18.121 8.191-.046-12.435 18.61 2.994-13.608H12.94L21.098.001h-1.972Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    d: "M25.502.002 13.807 35.771h15.505l-6.178 28.064 26.569-39.758-11.912.065L47.463.003H31.28l-.778 2.499h13.266l-9.68 24.161 10.92-.061-16.58 24.813 3.993-18.144H17.254L28.132.002h-2.63Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconLightning = function IconLightning(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Lightning' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Lightning"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconLightning.sizes = [16, 24, 32, 48, 64];
IconLightning.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconLightning;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/weather/Lightning.js
// module id = 2490
// module chunks = 0